import { render, staticRenderFns } from "./DropdownItem.vue?vue&type=template&id=7eba3b2b&scoped=true&"
import script from "./DropdownItem.vue?vue&type=script&lang=ts&"
export * from "./DropdownItem.vue?vue&type=script&lang=ts&"
import style0 from "./DropdownItem.vue?vue&type=style&index=0&id=7eba3b2b&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7eba3b2b",
  null
  
)

export default component.exports